import i18n from '@/i18n'
export default [
  // 选型分类列表
  {
    path: 'selectionCategoryList',
    component: () => import('@/views/modules/selectionInquiry/selectionCategoryList'),
    name: 'selectionCategoryList',
    meta: {
      title: i18n.t('route.selectionCategoryList'),
      isTab: true
    }
  },
  // 选型询价详情页
  {
    path: 'selectionInquiryDetail',
    component: () => import('@/views/modules/selectionInquiry/selectionInquiryDetail'),
    name: 'selectionInquiryDetail',
    meta: {
      title: i18n.t('route.selectionInquiryDetail'),
      isTab: true
    }
  },
  // 新建选型询价单
  {
    path: 'selectionInquiryCreate',
    component: () => import('@/views/modules/selectionInquiry/selectionInquiryCreate'),
    name: 'selectionInquiryCreate',
    meta: {
      title: i18n.t('route.selectionInquiryCreate'),
      isTab: true
    }
  },
  // 场景选型首页
  {
    path: 'sceneSelectionHome',
    component: () => import('@/views/modules/selectionInquiry/sceneSelectionHome'),
    name: 'sceneSelectionHome',
    meta: {
      title: '场景选型场景页',
      isTab: true
    }
  },
  // 场景选型场景页
  {
    path: 'sceneSelectionScene',
    component: () => import('@/views/modules/selectionInquiry/sceneSelectionScene'),
    name: 'sceneSelectionScene',
    meta: {
      title: '场景选型场景页',
      isTab: true
    }
  },
  // 设计选型页的首页
  {
    path: 'meterSelectionIndex',
    component: () => import('@/views/modules/selectionInquiry/meterSelection'),
    name: 'meterSelectionIndex',
    meta: {
      title: '设计选型',
      isTab: true
    }
  },
  // 设计选型参数配置页面
  {
    path: 'meterSelectionConfig',
    component: () => import('@/views/modules/selectionInquiry/meterSelectionConfig'),
    name: 'meterSelectionConfig',
    meta: {
      title: '需求配置',
      needToken: true
    }
  }
]
